<template>
    <v-card color="" class="text-xs-left white--text my-card">
        <v-card-title primary-title class="is-flex">
            <div class="headline">{{ title }}</div>
            <span class="grey--text text--lighten-1">{{ date }}</span>
        </v-card-title>
        <v-card-text>
            <span v-html="description"></span>
        </v-card-text>
        <!-- <v-card-actions>
            <v-btn flat dark>Listen now</v-btn>
        </v-card-actions> -->
    </v-card>
</template>

<script>
export default {
  name: 'New',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
    .my-card {
        right: 175px;
        min-width: 400px;
        margin: 5px;
    }

    .is-flex {
        display: flex;
        justify-content: space-between;
    }
</style>
